import axios from 'axios';
import JSZip from 'jszip';
import { zip } from 'lodash/fp';

interface DownloadArgs {
  url: string;
  filename: string;
}

export default async function download({ url, filename }: DownloadArgs) {
  const { data } = await axios({
    url,
    method: 'GET',
    responseType: 'blob',
  });
  downloadData({ data, filename });
}

export async function downloadData({ data, filename }: { data: string; filename: string }) {
  const downloadUrl = URL.createObjectURL(new Blob([data]));

  // Trigger file download by triggering click event on a link
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.setAttribute('download', filename);

  // Actually adding element to DOM is needed for older browsers
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export async function downloadFiles(files: Array<DownloadArgs>, zipFileName: string) {
  const filesData = await Promise.all(
    files.map(({ url }) =>
      axios({
        url,
        method: 'GET',
        responseType: 'blob',
      }),
    ),
  );
  const filenameCount: Record<string, number> = {};
  const getUniqueFileName = (filename: string) => {
    if (filenameCount[filename]) {
      filenameCount[filename] += 1;
      const [getFilenameWithoutExtension, extension] = filename.split('.');
      return `${getFilenameWithoutExtension} (${filenameCount[filename] - 1}).${extension}`;
    } else {
      filenameCount[filename] = 1;
      return filename;
    }
  };

  const zipFile = new JSZip();
  const fileDataAndName = zip(filesData, files);
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  fileDataAndName.map(([{ data }, { filename }]) =>
    zipFile.file(getUniqueFileName(filename), data),
  );
  const zipFileContent = await zipFile.generateAsync({ type: 'blob' });
  const downloadUrl = URL.createObjectURL(zipFileContent);

  // Trigger file download by triggering click event on a link
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.setAttribute('download', zipFileName);

  // Actually adding element to DOM is needed for older browsers
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
